import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

export const VariantsInfoAlert = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'catalog.products.form.variantsInfo',
  })

  return (
    <Alert variant="help">
      <Info />
      <AlertTitle>{t('title')}</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4 space-y-1">
          <li>{t('variant')}</li>
          <li>{t('descriptive')}</li>
          <li>{t('surcharge')}</li>
        </ul>
      </AlertDescription>
    </Alert>
  )
}
